module.exports = __webpack_public_path__ + "img/c08_buildingtechimprovedfletching_Normal_ua.88e090f4.webp";